<template>
  <form
    v-if="!needProof"
    class="callback-d"
    :class="{ '_success': showSuccess }"
    @submit.prevent="validate"
    @keyup.enter.prevent="validate"
  >
    <h2 class="callback-d__title">
      {{ title }}
    </h2>
    <p class="callback-d__desc" v-html="desc"></p>
    <div v-if="notify.caption" class="callback-d__notify">
      <notification :type="notify.type">
        {{ notify.caption }}
      </notification>
    </div>
    <template v-if="!showSuccess">
      <div class="callback-d__row">
        <form-item
          class="callback-d__cel _phone"
          v-bind="fieldValidation('phone')"
        >
          <input-phone-control
            ref="phoneInput"
            v-model.trim="phone"
            :disabled="isLoading"
          />
        </form-item>
        <form-item class="callback-d__cel">
          <button-control
            size="large"
            native-type="submit"
            :is-block="true"
            :loading="isLoading"
            :disabled="isLoading"
          >
            Заказать звонок
          </button-control>
        </form-item>
      </div>
      <div
        ref="recaptchaContainer"
        :class="{'callback-d__recaptcha': recaptchaWidget !== null}"
      ></div>
      <div class="callback-d__policy" v-html="policyText"></div>
    </template>
  </form>
  <sms-confirm
    v-else
    :phone="phone"
    @verified="handlerVerified"
    @cancel="needProof = false"
  />
</template>

<script>
import {
  Notification,
  ButtonControl,
  InputPhoneControl,
  FormItem,
} from '@book24/ui-components';

import CallbackFormMixin from '@/js/vue/Callback/form/CallbackFormMixin';

import SmsConfirm from '@/js/vue/SmsConfirm';

export default {
  name: 'CallbackFrom',
  components: {
    Notification,
    SmsConfirm,
    ButtonControl,
    InputPhoneControl,
    FormItem,
  },
  mixins: [CallbackFormMixin],
};
</script>
